import type { BrandInsightsPageContext, Chat } from '@trinity/chat';
import { BrandInsightChatContexts, ChatContextType } from '@trinity/chat';
import { generateEmptyChatSessionFiltersState } from '@trinity/chat-components/components/Chat.State/state.initial-state';

export function calculateIfFiltersActive(data: CalculateActiveCount) {
  return calculateActiveFiltersCount(data) > 0;
}

export function calculateActiveFiltersCount({ context, data, features }: CalculateActiveCount) {

  if (context.type === ChatContextType.Agent && !BrandInsightChatContexts.includes(context.data.identifier)) {
    return 0;
  }

  let count = data.custom.length;
  const defaults = generateEmptyChatSessionFiltersState({ context, features });

  // Check sources
  if (JSON.stringify((data.sources || []).concat().sort((a, b) => a.id.localeCompare(b.id))) != JSON.stringify(defaults.sources.concat().sort((a, b) => a.id.localeCompare(b.id)))) count++;
  // Check Publish date
  if (data.minDocumentDate != defaults.minDocumentDate) count++;
  // Check tags
  if (data.tags.length) count++;
  // Check data sources
  if (JSON.stringify((data.dataSources || []).concat().sort((a, b) => a.id.localeCompare(b.id))) != JSON.stringify(defaults.dataSources.concat().sort((a, b) => a.id.localeCompare(b.id)))) count++;
  // Check records
  if (data.records?.length && context.type === ChatContextType.Global) {
    count += data.records.length;
  }
  if (data.projects.length) count++;
  // Check engagement source
  if (features.engagementFilter && data.engagement?.id !== 'all' && [
    ChatContextType.Global,
    ChatContextType.KolProfile,
  ].includes(context.type)) {
    count++;
  }

  return count;
}

type CalculateActiveCount = {
  context: BrandInsightsPageContext.Item;
  data: Chat.Filters;
  features: {
    hcpProfiles: boolean;
    workspaces: boolean;
    engagementFilter: boolean;
  }
};